define.alias("ember-math-helpers/helpers/random", "media/helpers/random");